import cx from 'classnames';
import { useContext } from 'react';
import useHandleInternalLinks from '@/hooks/useHandleInternalLinks';
import Container from '@/next-components/container';
import Blocks from '@/next-components/blocks';
import { ThemeContext } from '@/contexts/theme-context';
import omit from '@/utils/omit';
import { getStyles } from './styles.css';
import { SinglePageThemeControls } from './theming';

export default function Page({ node }) {
	const blocks = node?.blocksJSON ? JSON.parse(node.blocksJSON) : [];

	const handleInternalLinks = useHandleInternalLinks();

	// Merge: defaults + theme (variant base + variant active)
	const { rawTheme, theme } = useContext(ThemeContext);
	const blockTheme = theme?.['templates']?.[SinglePageThemeControls.slug]; // theme
	const tokensTheme = rawTheme?.tokens; // tokens
	const finalTheme = omit(blockTheme, ['variants']);
	// console.log('::: Final Theme ::: ', finalTheme);

	const rootClass = cx('supt-singlePage', getStyles(tokensTheme, finalTheme));

	return (
		<>
			<Blocks blocks={blocks} includes={/^supt\/header-a/g} />
			<Container className={rootClass} onClick={handleInternalLinks}>
				<Blocks blocks={blocks} excludes={/^supt\/header-a/g} />
			</Container>
		</>
	);
}
